import styles from "./Widget.module.css";

export default function TitleCardWidget({ title, headerRight, className = "", titleClassName = "", children }) {
    return (
        <div className={`${styles.card} ${className}`}>
            {title && (
                <div className={`${styles.card__header} ${titleClassName}`}>
                    <div className={styles.cardHeaderLeft}>{title}</div>
                    {headerRight && <div className={styles.cardHeaderRight}>{headerRight}</div>}
                </div>
            )}
            <div className={styles.card__body}>
                {children}
            </div>
        </div>
    );
}
